export default __webpack_public_path__ + "static/media/lawnMowing.627f5dea.jpg";